interface WhyChooseTorfx {
  title: string;
  text: string;
}

export const whyChooseTorfx: WhyChooseTorfx[] = [
  {
    title: '24/7 Transfers',
    text: 'Transfer online, through our app or over the phone with your Account Manager.',
  },
  {
    title: '5 Star Service',
    text: 'Benefit from personal account management, award-winning support and expert insight.',
  },
  {
    title: 'Highest Credit Rating',
    text: 'We were established in 2004 and hold the highest credit rating with Dun & Bradstreet.',
  },
  {
    title: 'Excellent Rates',
    text: 'Make fee-free currency transfers at excellent exchange rates',
  },
];
